import { Injectable, inject } from '@angular/core';

import { map, type Observable } from 'rxjs';

import { HttpApiService } from '@core/http-legacy';
import type { LanguageConfigType, LanguageSettings } from '@core/languages-types';

@Injectable({ providedIn: 'root' })
export class LanguageConfigHttpService {
  protected readonly httpApi = inject(HttpApiService);

  public fetchLanguageConfig(): Observable<LanguageConfigType> {
    return this.httpApi.get(`/lang/settings`).pipe(map(res => (res.data ? res.data[0] : res)));
  }

  public updateLanguageConfig(settings: Partial<LanguageSettings>): Observable<LanguageConfigType> {
    return this.httpApi.patch(`/lang/settings`, null, { settings });
  }
}
